<template>
  <component :is="componentType" :viewBox="viewBox">
    <template v-if="type=='svg'">
      <line v-for="l in modifiedLinks" :x1="l.source.x" :y1="l.source.y" :x2="l.target.x" :y2="l.target.y" :style="'stroke:black;'" />
      <circle v-for="c in modifiedNodes" :r="c.radius" :cx="withinBounds(c,'x')" :cy="withinBounds(c,'y')" :style="'fill:'+fill(c)"></circle>
    </template>
    <slot></slot>
  </component>
</template>
<script>
import { select, randomUniform } from 'd3';
const d3 = require('d3')
window._ = require('lodash')
window.d3 = d3
export default {
  name: 'force-diagram',
  props: {
    type: {
      type: String,
      default: 'svg'
    },
    height:Number,
    width:Number,
    responsive:Boolean,
    nodes: {
      type: Array,
      default: () => []

    },
    links: {
      type: Array,
      default: () => []
    },
    radius: {
      type: Number,
      default: 10,
    },
    padding: {
      type: Number,
      default: 5
    },
    chargeStrength: Number,
    clusterStrength: Number,
    collideStrength: Number,
    centerActive: {
      type: Boolean,
      default: true
    },
    chargeActive: {
      type: Boolean,
      default: true
    },
    clusterActive: {
      type: Boolean,
      default: true
    },
    collideActive: {
      type: Boolean,
      default: true
    },
  },
  mounted() {
    this.build()
  },
  watch: {
    radius() { this.createSimulation() },
    padding() { this.createSimulation() },
    chargeStrength() { this.createSimulation() },
    clusterStrength() { this.createSimulation() },
    collideStrength() { this.createSimulation() },
    chargeActive() { this.createSimulation() },
    clusterActive() { this.createSimulation() },
    collideActive() { this.createSimulation() },
    nodes: {
      handler(newNodes, oldNodes) {
        this.redraw()
        // console.log('nodes changed', newNodes, oldNodes)
      },
      immediate: true
    },
    links: {
      handler(newNodes, oldNodes) {
        this.redraw()
        // console.log('nodes changed', newNodes, oldNodes)
      },
      immediate: true
    },
  },
  mounted() {
    console.log('mounted', this.type)
    this.build()
  },
  data() {
    return {
      particles: 1000,
      positions: null,
      dx: 2,
      sizes: null,
      modifiedNodes: [],
      modifiedLinks: [],
    }
  },
  computed: {
    componentType() {
      return this.type == 'webgl' || this.type == 'canvas' ? 'canvas' : 'svg'
    },
    viewBox() { return "0 0 " + this.width + " " + this.height + "" },

  },
  methods: {
    redraw: _.debounce(function() {
      console.log('redraw')
      this.build()
    }, 100),
    build() {
      console.log('build', this.$el)
      this.groups = []
      this.clusters = new Array(_.size(this.groups));

      this.setupNodesAndLinks()

      this.createSimulation()
    },
    withinBounds(node, axis) {
      if (axis == 'x') node.x = Math.max(node.radius, Math.min(this.width - node.radius, node.x));
      if (axis == 'y') node.y = Math.max(node.radius, Math.min(this.height - node.radius, node.y));
      return node[axis]
    },
    setupNodesAndLinks() {
      var modifiedNodes = _.map(this.nodes, (d) => {
        var radius = this.radius
        if (d.group) {
          if (!this.groups[d.group]) this.groups[d.group] = 0
          this.groups[d.group]++
        }
        var d = {
          radius: this.radius,
          group: d.group,
          x: Math.cos(d.group / this.nodes.length * 2 * Math.PI) * 200 + this.width / 2 + Math.random(),
          y: Math.sin(d.group / this.nodes.length * 2 * Math.PI) * 200 + this.height / 2 + Math.random()
        }
        if (!this.clusters[d.group] || (radius > this.clusters[d.group].radius)) this.clusters[d.group] = d;
        return d
      })
      this.modifiedNodes = _.clone(modifiedNodes)
      this.modifiedLinks = _.clone(this.links)
    },
    setupScene() {
      var self = this
      this.svg = d3.select(this.$el)
    },
    groupColour(group) {
      var col = d3.scaleSequential(d3.interpolateRainbow).domain(d3.range(_.size(this.groups)));
      return col(group / this.groups.length)
    },
    fill(c) {
      if (c.group) return this.groupColour(c.group)
      else return '#1f5293'
    },
    createSimulation() {
      var self = this
      this.simulation = d3.forceSimulation(this.modifiedNodes);
      if (this.chargeActive) this.simulation.force('charge', d3.forceManyBody().strength(this.chargeStrength))
      if (this.centerActive) this.simulation.force('center', d3.forceCenter(this.width / 2, this.height / 2))
      if (this.clusterActive) this.simulation.force('cluster', this.cluster().strength(this.clusterStrength))
      if (this.collideActive) this.simulation.force('collide', d3.forceCollide(d => d.radius + this.padding).strength(this.collideStrength))
      if (this.links) this.simulation.force("link", d3.forceLink(this.links))
    },

    xCenter(group) {
      return this.width / 2
    },
    drawLink(d) {
      this.context.beginPath();
      this.context.strokeStyle = "#aaa";
      this.context.moveTo(d.source.x, d.source.y);
      this.context.lineTo(d.target.x, d.target.y);
      this.context.stroke();
    },
    drawNode(d, a) {
      var x = this.withinBounds(d, 'x')
      var y = this.withinBounds(d, 'y')
      this.context.beginPath();
      this.context.fillStyle = this.groupColour(d.group);
      // this.context.strokeStyle = "#aaa";
      this.context.moveTo(x + d.radius, y);
      this.context.arc(x, y, d.radius, 0, 2 * Math.PI);
      this.context.fill();
      // this.context.stroke();

    },
    cluster() {
      var self = this

      var nodes,
        strength = 0.1;

      function force(alpha) {

        // scale + curve alpha value
        alpha *= strength * alpha;
        _.each(self.modifiedNodes, (d) => {
          // self.modifiedNodes.forEach(function(d) {
          //   console.log(d) 
          var cluster = self.clusters[d.group];
          // console.log(cluster) 
          if (cluster === d) return;

          let x = d.x - cluster.x,
            y = d.y - cluster.y,
            l = Math.sqrt(x * x + y * y),
            r = d.radius;

          if (l != r) {
            l = (l - r) / l * alpha;
            d.x -= x *= l;
            d.y -= y *= l;
            cluster.x += x;
            cluster.y += y;
          }
          // });
        })

      }

      force.initialize = function(_) {
        nodes = _;
      }

      force.strength = _ => {
        strength = _ == null ? strength : _;
        return force;
      };

      return force;

    },

  }
}

</script>
